"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _IconProps = _interopRequireDefault(require("./IconProps"));

var _SVGFragment = _interopRequireDefault(require("./SVGFragment"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var IconSearch = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var classes = _ref.classes;
  return /*#__PURE__*/_react.default.createElement(_SVGFragment.default, {
    classes: classes,
    iconClassName: "icon__search",
    width: 28,
    height: 28,
    ref: ref
  }, /*#__PURE__*/_react.default.createElement("g", {
    transform: "translate(-1189.000000, -150.000000)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(1189.000000, 150.000000)",
    stroke: "#707070",
    strokeWidth: "2",
    d: "M10.212421,23.0915086 C15.1162057,23.0915086 19.0915086,19.1162057 19.0915086,14.212421 C19.0915086,9.30863628 15.1162057,5.33333333 10.212421,5.33333333 C5.30863628,5.33333333 1.33333333,9.30863628 1.33333333,14.212421 C1.33333333,19.1162057 5.30863628,23.0915086 10.212421,23.0915086 Z M16.5128205,20.5128205 L22.6666667,26.6666667"
  })));
});
IconSearch.displayName = 'IconSearch';
IconSearch.propTypes = _IconProps.default.propTypes;
IconSearch.defaultProps = _IconProps.default.defaultProps;
var _default = IconSearch;
exports.default = _default;